import AuraFXPage from "@/components/AuraFXPage";

const AuraEURUSD = () => {
  return (
    <AuraFXPage 
      instrument="EURUSD" 
      name="EUR/USD" 
      apiPath="/aura/eurusd" 
      intradaySymbol="EURUSD=X"
    />
  );
};

export default AuraEURUSD;
